import { Mixpanel } from 'mixpanel-react-native';
import { MIXPANEL_TOKEN, IS_PRODUCTION } from '../constants/CommonConstants';

const trackAutomaticEvents = false;

class AnalyticsService {
    private static instance: AnalyticsService;
    private mixpanel: Mixpanel | null = null;
    private isInitialized = false;

    private constructor() { }

    public static getInstance(): AnalyticsService {
        if (!AnalyticsService.instance) {
            AnalyticsService.instance = new AnalyticsService();
        }
        return AnalyticsService.instance;
    }

    public async init(): Promise<void> {
        if (this.isInitialized) {
            return;
        }

        if (!IS_PRODUCTION) {
            console.log('Mixpanel disabled (Not Production)');
            return;
        }

        try {
            this.mixpanel = new Mixpanel(MIXPANEL_TOKEN, trackAutomaticEvents);
            await this.mixpanel.init();
            this.isInitialized = true;
            console.log('Mixpanel initialized successfully');
        } catch (error) {
            console.error('Failed to initialize Mixpanel:', error);
        }
    }

    public track(eventName: string, properties?: Record<string, any>): void {
        if (!this.isInitialized || !this.mixpanel) {
            console.warn('Mixpanel not initialized. Event not tracked:', eventName);
            return;
        }

        try {
            this.mixpanel.track(eventName, properties);
        } catch (error) {
            console.error(`Failed to track event ${eventName}:`, error);
        }
    }

    public identify(userId: string): void {
        if (!this.isInitialized || !this.mixpanel) {
            return;
        }
        this.mixpanel.identify(userId);
    }

    public reset(): void {
        if (!this.isInitialized || !this.mixpanel) {
            return;
        }
        this.mixpanel.reset();
    }
}

export default AnalyticsService.getInstance();
